import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import classNames from "classnames";

import useResumeHandlers from "../hooks/useResumeHandlers";

import Loading from "../../../../../components/Loading";
import { selectSelectedTeam } from "../../../../../features/clubhouse/clubhouseSlice";
import { selectSetting } from "../../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";

const ResumeForm = (): React.JSX.Element => {
    const [sending, setSending] = useState<boolean>(false);
    const selectedTeam = useAppSelector(selectSelectedTeam);
    const resumeQuestions = useAppSelector(state =>
        selectSetting(state, "majorybl_resume_questions"),
    );
    const { handleSubmit } = useResumeHandlers({ selectedTeam, setSending });

    return (
        <Form
            id="clubhouseTeamResumeForm"
            onSubmit={handleSubmit}
            data-testid="clubhouseTeamResumeForm"
        >
            {resumeQuestions?.setting.map(
                (r: { id: number; question: string }) => (
                    <Row key={r.id}>
                        <Col>
                            <Form.Group
                                controlId={`question${r.id}`}
                                data-testid={`question${r.id}`}
                            >
                                <div className="questionHeader">
                                    <Form.Label>Question #{r.id}</Form.Label>
                                    <p>{r.question}</p>
                                </div>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    name={`question${r.id}`}
                                    defaultValue={
                                        selectedTeam?.resume?.find(
                                            q => q.question === r.id,
                                        )?.answer || ""
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                ),
            )}
            <Row>
                <Col className={classNames("d-flex", "align-items-baseline")}>
                    <Button variant="primary" type="submit" disabled={sending}>
                        Update Resume
                    </Button>
                    {sending && <Loading className="mx-3 w-auto" />}
                </Col>
            </Row>
        </Form>
    );
};

export default ResumeForm;
